import * as React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { useTheme } from '../../../../../theming/useTheme';
import { footerSectionPadding } from '../footer.utils';
import { TextLinkComponent } from '../../../../partials/link/TextLink';
import { ErrorBoundary } from '../../../../errorHandling/ErrorBoundary';
import { H4, semanticCSS } from '../../../../../typography/semanticTags';
import { BaseUnit } from '../../../../../theming/baseUnitDefinition';

const componentConfigurationKey = 'footerMobileStores';

interface StoreLink {
  href: string
  src: string
  alt: string
}

export interface FooterMobileStoresBaseProps {
  title: string
  imageLinks: StoreLink[]
}

interface MobileStoresThemeProps {
  baseUnit: BaseUnit
  color: string
}

const getStyle = (theme: MobileStoresThemeProps, numColumns: number = 2) => {
  const { baseUnit } = theme;
  const padding = footerSectionPadding(baseUnit);
  const columns = Array(numColumns).fill('auto').join(' ');

  return StyleSheet.create({
    section: {
      ...padding,
    },
    title: {
      textAlign: 'center',
      color: theme.color,
    },
    storesWrapper: {
      display: 'grid',
      gridTemplateColumns: columns,
      justifyContent: 'center',
      gridGap: `${baseUnit * 0.5}px`,
      marginTop: `${baseUnit * 0.5}px`,
    },
    storeItem: {
      backgroundColor: 'wheat',
    },
  });
};

const createStoreItem = (storeLink: StoreLink, index: number) => {
  return (
    <TextLinkComponent href={storeLink.href} key={index} target="_blank">
      <img alt={storeLink.alt} src={storeLink.src} height="40" />
    </TextLinkComponent>
  );
};

export const FooterMobileStoresComponent = (props: MobileStoresThemeProps & FooterMobileStoresBaseProps) => {
  const { title, imageLinks } = props;
  const style = getStyle(props, imageLinks.length);
  return (
    <div className={css(style.section)}>
      <H4 styles={semanticCSS(style.title)}>{title}</H4>
      <div className={css(style.storesWrapper)}>
        {
          imageLinks.map(createStoreItem)
        }
      </div>
    </div>
  );
};

const mapThemeProps = (theme: MobileStoresThemeProps) => ({
  baseUnit: theme.baseUnit,
  color: theme.color,
});

export const FooterMobileStores = (props: FooterMobileStoresBaseProps) => {
  const themeContext = useTheme(mapThemeProps, componentConfigurationKey);
  return <ErrorBoundary><FooterMobileStoresComponent {...themeContext} {...props} /></ErrorBoundary>;
};
